export const EVENTS = {
    MODAL_OPEN: 'Cookie modal open',
    BANNER_OPEN: 'Cookie banner open',
    GDPR_ACCEPT_ALL: 'GDPR Accept All',
    GDPR_REJECT_ALL: 'GDPR Reject All',
    GDPR_PREF_ALLOWS_1: 'GDPR Pref Allows 1',
    GDPR_PREF_ALLOWS_2: 'GDPR Pref Allows 2',
    GDPR_PREF_ALLOWS_3: 'GDPR Pref Allows 3'
};

export const addNewRelicPageAction = (actionName: any, actionObject: any) => {
    // eslint-disable-next-line no-unused-expressions
    // @ts-expect-error TS2339: Property 'newrelic' does not exist on type 'Window & typeof globalThis'.
    window.newrelic?.addPageAction(actionName, actionObject);
};

export const addNewRelicError = (error: any, customAttributes: any) => {
    // eslint-disable-next-line no-unused-expressions
    // @ts-expect-error TS2339: Property 'newrelic' does not exist on type 'Window & typeof globalThis'.
    window.newrelic?.noticeError(error, customAttributes);
};

export const setNewRelicAttribute = (attribute: any, value: any) => {
    // eslint-disable-next-line no-unused-expressions
    // @ts-expect-error TS2339: Property 'newrelic' does not exist on type 'Window & typeof globalThis'.
    window.newrelic?.setCustomAttribute(attribute, value);
};
